import type { PropsWithChildren } from "react";

import { useNetworkConnectivity } from "~/features/network-connectivity/use-network-connectivity";
import { QUERY_CLIENT_PERSISTER } from "~/features/query-cache/queries";
import { useInitialQueryClient } from "~/features/query-cache/use-initial-query-client";

import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { toMilliseconds } from "duration-fns";

export const QueryCacheProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isOnline } = useNetworkConnectivity();
  const queryClient = useInitialQueryClient();
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: QUERY_CLIENT_PERSISTER,
        maxAge: toMilliseconds({ weeks: 1 }),
      }}
      onSuccess={() => {
        if (isOnline) {
          // resuming mutations on mount and online
          void queryClient.resumePausedMutations();
        }
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
};
